import React from 'react';
import { Link } from 'react-router-dom';
import { IArrowLink } from './types.type';
import { ArrowLeft } from '../icons';

export const ArrowLink = ({ to, linkText }: IArrowLink) => (
  <div className="text-center mx-auto ">
    <span className="text-base-black text-center mx-auto relative flex flex-row items-center gap-[6px] text-base-black font-body text-[16px] font-medium hover:text-blue-600">
      <ArrowLeft />
      <Link to={to} className=" ">
        {linkText}
      </Link>
    </span>
  </div>
);
